import Button from 'Components/Button';
import PropTypes from 'prop-types';

const ButtonMap = (props) => {
  const { longitude, latitude } = props;
  const openMap = () => {
    const url = `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;
    window.open(url, '_blank');
  };
  return <Button iconprefix={['fa', 'map-location']} onClick={() => openMap()} />;
};

ButtonMap.propTypes = {
  /**
   * Button label
   */
  longitude: PropTypes.string,
  latitude: PropTypes.string
};

export default ButtonMap;
